var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvtar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.285645,
    y: 0.148438,
    width: 23.3407,
    height: 23.3407,
    rx: 5.18681,
    fill: "#212121",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9563 11.8189C13.4483 11.8189 14.6578 10.6095 14.6578 9.11748C14.6578 7.6255 13.4483 6.41602 11.9563 6.41602C10.4644 6.41602 9.25488 7.6255 9.25488 9.11748C9.25488 10.6095 10.4644 11.8189 11.9563 11.8189Z",
    stroke: "#212121",
    strokeWidth: 0.972528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31494 17.2215C7.31494 15.1306 9.39507 13.4395 11.9561 13.4395C12.4747 13.4395 12.9772 13.5097 13.4473 13.6394",
    stroke: "#212121",
    strokeWidth: 0.972528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.359 15.0606C17.359 15.4658 17.2455 15.8494 17.0456 16.1736C16.9321 16.3681 16.7863 16.541 16.6188 16.6815C16.2406 17.0219 15.7435 17.2218 15.1978 17.2218C14.409 17.2218 13.7228 16.8003 13.35 16.1736C13.1501 15.8494 13.0366 15.4658 13.0366 15.0606C13.0366 14.3798 13.35 13.7693 13.8471 13.3749C14.2199 13.0777 14.6899 12.8994 15.1978 12.8994C16.3918 12.8994 17.359 13.8665 17.359 15.0606Z",
    stroke: "#212121",
    strokeWidth: 0.972528,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.355 15.0607L14.8899 15.5956L16.0407 14.5312",
    stroke: "#212121",
    strokeWidth: 0.972528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvtar);
export default __webpack_public_path__ + "static/media/userAvtar.f1faff1b82460635f8340dcd797a079d.svg";
export { ForwardRef as ReactComponent };